export default "__VITE_ASSET__c6N$DlPh__"